(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["minx-fragrance-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('minx-fragrance-description')) {
    customElements.define('minx-fragrance-description', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('[data-section-type="product"]');
        this.output = this.querySelector('[data-fragrance-text]');
        this.entries = Array.from(this.querySelectorAll('template[data-fragrance-id]'));
        if (!this.root || !this.output) return;
        this.onChange = () => {
          const controls = this.root.querySelector('[data-product-variants]');
          if (!controls) return;
          const values = Array.from(controls.querySelectorAll('select[name^="options["], input[name^="options["]:checked')).map(input => input.value);
          const entry = this.entries.find(item => {
            const options = JSON.parse(item.dataset.fragranceOptions);
            return options.length === values.length && options.every((option, index) => option === values[index]);
          });
          this.showEntry(entry);
        };
        this.onVariant = event => {
          const id = event.detail && event.detail.variant && String(event.detail.variant.id);
          const entry = this.entries.find(item => item.dataset.fragranceId === id);
          if (entry) this.showEntry(entry);
        };
        this.root.addEventListener('change', this.onChange);
        document.addEventListener('product:variant-change', this.onVariant);
        this.onChange();
      }
      showEntry(entry) {
        this.output.replaceChildren();
        if (entry) this.output.append(entry.content.cloneNode(true));
        this.hidden = !this.output.textContent.trim();
      }
      disconnectedCallback() {
        if (this.root && this.onChange) this.root.removeEventListener('change', this.onChange);
        if (this.onVariant) document.removeEventListener('product:variant-change', this.onVariant);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
